import React from 'react';
import { SvgIcon } from '@mui/material';

function FileFolderEditIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24" width={32} height={32}>
      <path
        d="M21 8V7C21 6.44771 20.5523 6 20 6L3 6L3 19C3 19.5523 3.44772 20 4 20H7"
        stroke="currentColor"
        fill="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 21H13.5L21 13.5L18.5 11L11 18.5V21Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 14L18 16"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6L10.2929 4.29289C10.1054 4.10536 9.851 4 9.58579 4H4C3.44772 4 3 4.44772 3 5V6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default FileFolderEditIcon;
